import { FC } from "react";
import { ColorTheme } from "shared/theme/theme";
import { useTheme } from "styled-components";

// Utility function to create a component with default props
export function withDefaults<P extends Record<string, any>>(
  Component: FC<P>,
  defaultProps: (theme: ColorTheme) => Partial<P>,
): FC<P> {
  // eslint-disable-next-line func-names -- generic function
  return function (props: P) {
    const theme = useTheme();
    const finalProps = { ...defaultProps(theme), ...props };
    return <Component {...finalProps} />;
  };
}
